import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconFileComponent } from "./med-icon-file.component";

@NgModule({
  declarations: [
    MedIconFileComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconFileComponent,
  ],
})
export class MedIconFileModule { }
